// extracted by mini-css-extract-plugin
export default {"breakdowntitle":"No","result_page":"Oo","what_are_calories":"Po","title":"Qo","copy":"Ro","chart":"So","to_reach":"To","title_wrapper":"Uo","rhode_percent":"Vo","what_are_macro":"Wo","text":"Xo","img":"Yo","macros_wrapper":"Zo","macros":"ap","macro_item":"bp","value":"cp","note":"ep","btn":"fp","carbo_item":"gp","faq":"hp","faq_items":"ip"};
    if(module.hot) {
      // 1737143653682
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  